import React from "react";
import { STORAGE_ASSETS } from "../../Const/BaseUrlConst";

type HeartRedProps = React.HTMLAttributes<HTMLDivElement> & {};

export const HeartRed: React.FC<HeartRedProps> = ({ ...props }) => {
  return (
    <div {...props}>
      <img src={STORAGE_ASSETS+"/images/png/heart_red.png"} alt="" />
    </div>
  );
};